import request from '@/utils/request'
// 分页列表
export function productSkuPageList(query, data) {
  return request({
    url: '/power/goods/productSku/pageList',
    method: 'post',
    params: query,
    data,
  })
}

// 分页列表-弹框使用
export function productSkuChoosePageList(query, data) {
  return request({
    url: '/power/goods/productSku/choose/pageList',
    method: 'post',
    params: query,
    data,
  })
}

// 单品货品关联集合
export function productSkuRelationList(query) {
  return request({
    url: '/power/goods/productSku/relation/list',
    method: 'get',
    params: query,
  })
}

// 详情
export function productSkuDetail(query) {
  return request({
    url: '/power/goods/productSku/detail',
    method: 'get',
    params: query,
  })
}

// 新增
export function productSkuAdd(data) {
  return request({
    url: '/power/goods/productSku/add',
    method: 'post',
    data: data,
  })
}

// 编辑
export function productSkuEdit(data) {
  return request({
    url: '/power/goods/productSku/edit',
    method: 'post',
    data: data,
  })
}

// 批量修改单品重量
export function productSkuEditSkuWeight(data) {
  return request({
    url: '/power/goods/productSku/edit/skuWeight',
    method: 'post',
    data: data,
  })
}

// 批量修改价格区间
export function productSkuEditPrice(data) {
  return request({
    url: '/power/goods/productSku/edit/price',
    method: 'post',
    data: data,
  })
}

// 批量修改零售价
export function productSkuEditRetailPrice(data) {
  return request({
    url: '/power/goods/productSku/edit/retailPrice',
    method: 'post',
    data: data,
  })
}

// 批量修改销售平台
export function productSkuEditPlatform(data) {
  return request({
    url: '/power/goods/productSku/edit/platform',
    method: 'post',
    data: data,
  })
}

// 批量设置标签
export function productSkuEditLabel(data) {
  return request({
    url: '/power/goods/productSku/edit/label',
    method: 'post',
    data: data,
  })
}

// 批量设置库存共享
export function productSkuEditStockShare(data) {
  return request({
    url: '/power/goods/productSku/edit/stockShare',
    method: 'post',
    data: data,
  })
}

// 批量设置预留库存
export function productSkuEditLockStatus(data) {
  return request({
    url: '/power/goods/productSku/edit/lockStatus',
    method: 'post',
    data: data,
  })
}

// 批量设置结算价
export function productSkuEditSettlePrice(data) {
  return request({
    url: '/power/goods/productSku/edit/settlePrice',
    method: 'post',
    data: data,
  })
}

// 导入
export function productSkuImport(data) {
  return request({
    url: '/power/goods/productSku/import',
    method: 'post',
    data: data,
  })
}

// 导出
export function productSkuExport() {
  return '/power/goods/productSku/export'
}

// 单品编码关联属性-联动
export function productSkuAttribute(query) {
  return request({
    url: '/power/goods/productSku/attribute',
    method: 'get',
    params: query,
  })
}
